
const digest = '16de07672f127d7149fc0b19fa7bf348c8077dc5d7b59d6ded03d77e8f8b396e';
const classes = {"wrapper":"_wrapper_j52n2_1","closed":"_closed_j52n2_12","title":"_title_j52n2_16","arrowClose":"_arrowClose_j52n2_23","arrowOpen":"_arrowOpen_j52n2_34","filterTitle":"_filterTitle_j52n2_46"};
const css = `._wrapper_j52n2_1 {
  border-right: 1px solid #eaedf3;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  padding: 24px;
  overflow-y: scroll;
  max-width: 240px;
  min-width: 240px;
}

._closed_j52n2_12 {
  min-width: 55px;
}

._title_j52n2_16 {
  font-weight: 600;
  font-size: 14px;
  color: #1665d8;
  margin-bottom: 15px;
}

._arrowClose_j52n2_23 {
  width: 15px;
  height: 15px;
  background: url("/dist/icons/react/angles-left-solid.svg") no-repeat center;
  background-size: contain;
  margin-right: 7.5px;
  cursor: pointer;
  position: absolute;
  right: 14px;
}

._arrowOpen_j52n2_34 {
  width: 15px;
  height: 15px;
  background: url("/dist/icons/react/angles-right-solid.svg") no-repeat center;
  background-size: contain;
  margin-right: 7.5px;
  cursor: pointer;
  position: absolute;
  right: 10px;
  padding-right: 21px;
}

._filterTitle_j52n2_46 {
  writing-mode: tb-rl;
  font-size: 14px;
  font-weight: 500;
  color: #1665d8;
  margin-top: 25px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  